import React from 'react';
import { Icon } from '@iconify/react';

const Skills: React.FC = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="title-box text-center">
                        <h1 className="title-a">Skills</h1>
                        <div className="line-mf"></div>
                    </div>
                </div>
            </div>

            {/* Programming Languages */}
            <div className="skill-category">
                <h2 className="skill-category-title">Programming Languages</h2>
                <div className="skills-container">
                    <div className="skills-icon-container" data-tooltip="Python">
                        <Icon icon="devicon:python" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="C">
                        <Icon icon="vscode-icons:file-type-c" height="0.9em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="C++">
                        <Icon icon="vscode-icons:file-type-cpp3" height="0.96em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="C#">
                        <Icon icon="devicon:csharp" height="0.92em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="JavaScript">
                        <Icon icon="logos:javascript" height="0.82em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="TypeScript">
                        <Icon icon="devicon:typescript" height="0.83em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Swift">
                        <Icon icon="devicon:swift" height="0.95em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="PHP">
                        <Icon icon="devicon:php" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="VisualBasic">
                        <Icon icon="devicon:visualbasic" height="1em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Visual Basic for Applications (VBA)">
                        <Icon icon="vscode-icons:file-type-vba" height="1em" className="skills-icon" />
                    </div>
                </div>
            </div>

            {/* Application Development */}
            <div className="skill-category">
                <h2 className="skill-category-title">Application Development</h2>
                <div className="skills-container">
                    <div className="skills-icon-container" data-tooltip="HTML5">
                        <Icon icon="vscode-icons:file-type-html" height="0.94em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="CSS3">
                        <Icon icon="devicon:css3" height="0.87em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Bootstrap">
                        <Icon icon="devicon:bootstrap" height="1em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Flask">
                        <Icon icon="devicon:flask" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Django">
                        <Icon icon="skill-icons:django" height="0.9em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Django REST Framework">
                        <Icon icon="devicon:djangorest" height="1.105em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Node.js">
                        <Icon icon="logos:nodejs-icon" height="0.83em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="React">
                        <Icon icon="devicon:react" height="0.9em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Svelte">
                        <Icon icon="logos:svelte-icon" height="0.8em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Tailwind">
                        <Icon icon="devicon:tailwindcss" height="0.82em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Tauri">
                        <Icon icon="material-icon-theme:tauri" height="0.9em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Electron">
                        <Icon icon="skill-icons:electron" height="0.89em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="ASP.NET Core Web API">
                        <Icon icon="devicon:dotnetcore" height="0.9em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Arduino">
                        <Icon icon="skill-icons:arduino" height="0.87em" className="skills-icon" />
                    </div>
                </div>
            </div>

            {/* Databases & Data Management */}
            <div className="skill-category">
                <h2 className="skill-category-title">Databases & Data Management</h2>
                <div className="skills-container">
                    <div className="skills-icon-container" data-tooltip="SQL">
                        <Icon icon="vscode-icons:file-type-sql" height="0.94em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="SQL Server">
                        <Icon icon="devicon:microsoftsqlserver" height="0.83em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="MySQL">
                        <Icon icon="logos:mysql" height="0.75em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="SQLite">
                        <Icon icon="skill-icons:sqlite" height="0.87em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="MongoDB">
                        <Icon icon="devicon:mongodb-wordmark" height="1em" className="skills-icon" />
                    </div>
                </div>
            </div>

            {/* Data & Analytics */}
            <div className="skill-category">
                <h2 className="skill-category-title">Data & Analytics</h2>
                <div className="skills-container">
                    <div className="skills-icon-container" data-tooltip="R">
                        <Icon icon="mdi:language-r" height="1.1em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Minitab">
                        <Icon icon="devicon:minitab" height="0.82em" className="skills-icon" />
                    </div>
                </div>
            </div>

            {/* DevOps & Systems */}
            <div className="skill-category">
                <h2 className="skill-category-title">DevOps & Systems</h2>
                <div className="skills-container">
                    <div className="skills-icon-container" data-tooltip="Linux">
                        <Icon icon="devicon:linux" height="0.94em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Docker">
                        <Icon icon="vscode-icons:file-type-docker" height="1.3em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Docker Compose">
                        <Icon icon="catppuccin:docker-compose" height="0.9em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Node-RED">
                        <Icon icon="devicon:nodered" height="0.9em" className="skills-icon" />
                    </div>
                </div>
            </div>

            {/* Tools & IDEs */}
            <div className="skill-category">
                <h2 className="skill-category-title">Tools & IDEs</h2>
                <div className="skills-container">
                    <div className="skills-icon-container" data-tooltip="Git">
                        <Icon icon="logos:git-icon" height="0.88em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Jira">
                        <Icon icon="devicon:jira" height="0.92em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="PlatformIO">
                        <Icon icon="vscode-icons:file-type-platformio" height="0.92em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Visual Studio">
                        <Icon icon="devicon:visualstudio" height="0.85em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Visual Studio Code">
                        <Icon icon="vscode-icons:file-type-vscode" height="0.98em" className="skills-icon" />
                    </div>
                    <div className="skills-icon-container" data-tooltip="Android Studio">
                        <Icon icon="devicon:androidstudio" height="0.94em" className="skills-icon" />
                    </div>
                </div>
            </div>

            {/* Languages */}
            <div className="skill-category">
                <h2 className="skill-category-title">Languages</h2>
                <div className="languages-container">
                    <div className="achievements-card">
                        <div className="achievements-header">
                            <Icon icon="twemoji:flag-united-kingdom" className="language-flag" />
                            <div className="language-info">
                                <span className="language-name">English</span>
                                <span className="language-level">Native</span>
                            </div>
                        </div>
                    </div>
                    <div className="achievements-card">
                        <div className="achievements-header">
                            <Icon icon="twemoji:flag-turkey" className="language-flag" />
                            <div className="language-info">
                                <span className="language-name">Turkish</span>
                                <span className="language-level">Native</span>
                            </div>
                        </div>
                    </div>
                    <div className="achievements-card">
                        <div className="achievements-header">
                            <Icon icon="twemoji:flag-germany" className="language-flag" />
                            <div className="language-info">
                                <span className="language-name">German</span>
                                <span className="language-level">Conversational</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;